import { Group, Switch, SwitchProps, Text } from '@mantine/core';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export function ShowOnlyOutputsToggle(props: SwitchProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const toggle = useCallback(() => {
    const params = new URLSearchParams(searchParams.toString());
    props.checked ? params.delete('onlyOutputs') : params.set('onlyOutputs', 'true');
    params.delete('page');

    router.push(params ? '?' + params.toString() : '');
  }, [searchParams, router, props.checked]);

  return (
    <Group gap='xs'>
      <Switch
        color='teal.5'
        size='sm'
        styles={{
          thumb: {
            backgroundColor: 'dark.9',
            borderColor: 'dark.9',
          },
          track: { border: '1px solid dark.9' },
        }}
        {...props}
        onChange={toggle}
      />
      <Text size='sm'>Show only output models</Text>
    </Group>
  );
}
